module.exports = __webpack_public_path__ + "images/997d3165ba3d028f12ffcd1e43fa90a6.submitForm.png";